export var initialCountdown = 30;
export var accountLockedErrorMessageKey = 'auth:two_fa.account_locked_error';
export var invalidCodeErrorMessageKey = 'auth:two_fa.invalid_code_error';
export var codeExpiredErrorMessageKey = 'auth:two_fa.code_expired_error';
